import {ObservationDTO} from './ObservationDTO';

export class LineDTO {
  lineNo: number;
  lineType: string;
  itemCodeType: string;
  chargeableCode: string;
  chargeableTreatmentDate: string;
  chargeableTreatmentEndDate: string;
  chargeableStartTime: string;
  chargeableEndTime: string;
  chargeableQuantity: number;
  extendedCode: string; // extendedTariffCode
  repeatAuthorised: number;
  toothNumbers: number;
  labReferenceNumber: number;
  daysSupplied: number;
  billedAmount: number;
  grossAmount: number;
  nettAmount: number;
  Observation: ObservationDTO[];
  lineOverrideIndicator1: number;
  lineOverrideIndicator2: number;
  lineOverrideIndicator3: number;
  lineOverrideIndicator4: number;
  manualCopaymentPercentageOverride: number;
}
